import type { OapRow } from './evaluate';

export interface OapCounts { required: number; met: number; blocking: number }

/** Header counts only — no banner (D6). Advisory and report-only rows are not scored. */
export function oapCounts(rows: readonly OapRow[]): OapCounts {
  const scored = rows.filter((r) => r.scored);
  const met = scored.filter((r) => r.status === 'met').length;
  return { required: scored.length, met, blocking: scored.length - met };
}
